module.exports = __webpack_public_path__ + "img/img.0f4b03b2.png";